export default "__VITE_ASSET__3HoSUavV__"